'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @bit
 * @name cardStyle
 * @description Used for styling the Belle Card component
 */

var cardStyle = {

  style: {
    marginBottom: 20,
    padding: 40,
    borderRadius: 2,
    background: '#fff',
    boxShadow: '0 1px 1px rgba(0, 0, 0, 0.2)',
    boxSizing: 'border-box'
  }
};

exports.default = cardStyle;

//# sourceMappingURL=impl.js.map


// WEBPACK FOOTER //
// ./src/components/style/card-style/belle.react-components/3/dist/impl.js